export const BASEURL = "https://vobbiz-backend.azurewebsites.net";
export const FETCHURL = "https://vobbiz-backend.azurewebsites.net";
export const VOBBIZ_MAIL = "hej@vobbiz.se";
export const VOBBIZ_CALL = "tel:031-7456750";
